"use strict";

var _classCallCheck = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/classCallCheck.js").default;
var _createClass = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/createClass.js").default;
var _inherits = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/inherits.js").default;
var _createSuper = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/createSuper.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShortCSSToReactNativeValidator = void 0;
var _ShortCSSPropertyValidator = require("./ShortCSSPropertyValidator");
var _expandCSSToRN = _interopRequireDefault(require("./expandCSSToRN"));
var _ShortMergeRequest = require("../ShortMergeRequest");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var ShortCSSToReactNativeValidator = /*#__PURE__*/function (_ShortCSSPropertyVali) {
  _inherits(ShortCSSToReactNativeValidator, _ShortCSSPropertyVali);
  var _super = _createSuper(ShortCSSToReactNativeValidator);
  function ShortCSSToReactNativeValidator() {
    _classCallCheck(this, ShortCSSToReactNativeValidator);
    return _super.apply(this, arguments);
  }
  _createClass(ShortCSSToReactNativeValidator, [{
    key: "normalizeInlineCSSValue",
    value: function normalizeInlineCSSValue(value) {
      return new _ShortMergeRequest.ShortMergeRequest((0, _expandCSSToRN.default)(this.propertyName, value));
    }
    /**
     * Not supported on Native.
     * @param value
     */
  }, {
    key: "normalizeNativeValue",
    value: function normalizeNativeValue() {
      return null;
    }
  }]);
  return ShortCSSToReactNativeValidator;
}(_ShortCSSPropertyValidator.ShortCSSPropertyValidator);
exports.ShortCSSToReactNativeValidator = ShortCSSToReactNativeValidator;